import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/oneimg1.png";
import Couimgg from "../assets/img/oneimg2.png";
import Image1 from "../assets/img/courtest1.png";
import Image2 from "../assets/img/courtest4.png";
import Image3 from "../assets/img/courtest3.png";
import Image4 from "../assets/img/courtest2.png";

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';

import eventbg from '../assets/img/eventstylingbg.jpg';
import Icon11 from '../assets/img/one/icon8.jpg';
import Icon1 from '../assets/img/about/skill1.png';
import Icon2 from '../assets/img/about/skill2.png';
import Icon3 from '../assets/img/about/skill3.png';
import Icon4 from '../assets/img/about/skill4.png';
import Icon31 from '../assets/img/about/skill5.png';
import Icon41 from '../assets/img/about/skill6.png';
import Icon411 from '../assets/img/about/sign.png';


import Icon311 from '../assets/img/about/one_1.png';
import Icon32 from '../assets/img/about/one_2.png';
import Icon33 from '../assets/img/about/one_3.png';
import Icon34 from '../assets/img/about/one_4.png';
import Icon35 from '../assets/img/about/one_5.png';

import Icon5 from '../assets/img/one/icon5.jpg';
import Icon6 from '../assets/img/one/icon6.jpg';
import Icon7 from '../assets/img/one/icon7.jpg';
import Iconss11 from '../assets/img/one/icon9.jpg';
import Icon8 from '../assets/img/one/icon8.jpg';
import Icon9 from '../assets/img/one/icon9.jpg';
import Icon51 from '../assets/img/icon51.png';
import Icon61 from '../assets/img/icon61.png';
import Icon71 from '../assets/img/icon71.png';
import Icon81 from '../assets/img/icon81.png';
import Icon91 from '../assets/img/icon91.png';

import imgch from '../assets/img/eventleft.jpg';
import imgch1 from '../assets/img/one/bhavna.png';
import imgch2 from '../assets/img/one/eventtt.png';

import imgchh from '../assets/img/one/bhavna.png';
import imgchhh from '../assets/img/one/why_light.png';
import Iconline from '../assets/img/one/line_why.png';
import iconprogram from '../assets/img/one/program.png';
import iconwork from '../assets/img/one/will_work.png';
import iconline from '../assets/img/one/happen_line.png';
import iconwill from '../assets/img/one/will_work_line.png';

import SeoHelmet from "../components/SeoHelmet";
import iconstrt from "../assets/img/iconstartt.png";
import staricon from '../assets/img/starbtn.png';
import staricon1 from '../assets/img/r_arrow.png';
import dott from '../assets/img/dotts.png';


const EventStyling = () => {
 

useEffect(() => {
      document.body.classList.add('eventstyling-page');
  
      return () => {
        document.body.classList.remove('eventstyling-page');
      };
    }, []);

    const [activeVideo, setActiveVideo] = useState(null);
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: ""
    });

      const handleOpenModal = (videoSrc) => {
        setActiveVideo(videoSrc); // Set the active video source
      };
    
      const handleCloseModal = () => {
        setActiveVideo(null); // Clear the active video source
      };

     


      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };
       
    
      const handleRazorpayPayment = (courseType) => {

        if (!formData.name.trim()) {
          alert("Please enter your name.");
          return;
        }
        if (!formData.email.trim()) {
          alert("Please enter your email.");
          return;
        }
        if (!formData.phone.trim()) {
          alert("Please enter your phone number.");
          return;
        }
        const amount = courseType === "online" ? 50000 : 100000; // ₹500 for online, ₹1000 for offline
        const description = courseType === "online" ? "Online Course" : "Offline Course";

        const options = {
          key: "rzp_live_RqikICjLlTbO4w", // Replace with your Razorpay Key ID
          amount: amount * 100, // Amount in paise (1000 = ₹10)
          currency: "INR",
          name: "Bhavana Singh Courses",
          description: description,
          //image: "https://your-logo-url.com/logo.png", // Replace with your company logo URL
          handler: function (response) {
            const paymentId = response.razorpay_payment_id;
            //alert(`Payment successful. Payment ID: ${paymentId}`);
            window.location.href = `/success?payment_id=${paymentId}`;
          },
          prefill: {
            name: formData.name,
            email: formData.email,
            contact: formData.phone,
          },
          notes: {
            address: "Bhavana Singh",
          },
          theme: {
            color: "#3399cc",
          },
        };
    
        const razorpay = new window.Razorpay(options);
        razorpay.on("payment.failed", function (response) {
          alert(`Payment failed. Error: ${response.error.description}`);
        });
        razorpay.open();
      };


  const courses = {
    1: { title: "First Post", content: ( 
      <>
      
      </>
      ), },
    2: { title: "Second Post", content: ( 
      <>
      
      
      </>
      ), },
  };

 

  

  useEffect(() => {
       
    if (window.Swiper) {
      
     

      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3, 
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      
      });
       
     
    }
  }, []); 


  return (
    <>
  {/* <SeoHelmet
  title="One-on-One Personality & Style Transformation | Bhavana Singh"
  description="Private one-on-one personality and style transformation by Bhavana Singh. Build confidence, presence, communication, and a powerful personal image"
  
/> */}

    <section className="oneofone_section one_on_one one_one event_styling_section" style={{ backgroundImage: `url(${eventbg})` }}>
      <div class="container">
        <div className="contentone_outer">
          <div className="title_one">
            <h5>Look Curated. Feel Extraordinary.</h5>
            <h6>EVENT <span>-Styling</span></h6>
          </div>
          <div className="skillbox skillboxx">
            <h2>What You Get?</h2>
            <h3>1:1 Personal Styling <span>For Your Big Day</span></h3>
               <div className="detailss">
          <div className="detail_section">
            <div className="number">01</div>
            <div className="personal_detail">
               <h3>Wardrobe Curation</h3>
            <p>Handpicked outfit selection tailored to your event, body<br></br> type & personal vibe</p>
            </div>
           
          </div>
           <div className="detail_section">
            <div className="number">02</div>
            <div className="personal_detail">
               <h3>Total Look Direction</h3>
            <p>Expert guidance for hair, makeup & overall styling aesthetic</p>
            </div>
           
          </div>
           <div className="detail_section">
            <div className="number">03</div>
            <div className="personal_detail">
               <h3>Accessories & Finishing</h3>
            <p>Jewellery, footwear & every fine detail curated to elevate the look</p>
            </div>
           
          </div>
           <div className="detail_section">
            <div className="number">04</div>
            <div className="personal_detail">
               <h3>Look Coordination</h3>
            <p>Complete ensemble harmony — stand out beautifully<br></br> without overdoing it</p>
            </div>
           
          </div>
           <div className="detail_section">
            <div className="number">05</div>
            <div className="personal_detail">
               <h3>On-Day Presence</h3>
            <p>Live styling supervision & final finishing touches before you<br></br> make your entrance</p>
            </div>
           
          </div>
           
         </div>
          </div>
         
          {/* <div className="skillbox_content">
              <h3>At the End of the Course You Will </h3>
              <p>Own every room you step into — a personality that speaks louder than words, a confidence that opens<br></br> doors, and a complete transformation in how you show up, express yourself, and leave a lasting impact.</p>
          </div> */}
          <div className="onedetails_section">
            {/* <div className="skillbox">
                   <ul>
                <li><img className="icon1" src={Icon1}></img><spna>Professionals looking<br></br> to boost confidence<br></br> and presence</spna></li>
                <li><img className="icon2" src={Icon2}></img><spna>Entrepreneurs preparing to<br></br> step out more confidently<br></br> into the world</spna></li>
                <li><img className="icon3" src={Icon3}></img><spna>Creators and leaders<br></br> who want stronger<br></br> personal impact</spna></li>
                <li><img className="icon4" src={Icon4}></img><spna>Individuals exploring<br></br> a new phase or <br></br>direction in life</spna></li>
                <li><img className="icon5" src={Icon31}></img><spna>Anyone who wants to<br></br> build a stronger, more <br></br>confident personality</spna></li>
                <li><img className="icon6" src={Icon41}></img><spna>Homemakers<br></br> rediscovering confidence <br></br>and personal identity</spna></li>
              </ul>
            </div> */}
            {/* <div className="skillbox1">
                <img src={Icon411}></img>
                <div className="skillbox1_content">
                  <h2>A private, personalised<br></br> journey designed only for you.</h2>
                  <p>This is Bhavna Singh’s most exclusive<br></br> offering, created for individuals who want <br></br>focused attention, deep inner–outer work,<br></br> and complete confidentiality.</p>
                </div>
            </div> */}
          </div>

          <div className="onedetails">
              {/* <div className="details_col">
                  <h2>Details:</h2>
                   <ul>
                      <li><h4>Duration</h4><spna>4 Days</spna></li>
                      <li><h4>location</h4><spna>In-Person, Fully Private</spna></li>
                      <li><h4>fees</h4><spna> ₹2,00,000 + GST</spna></li>
                    </ul>
              </div> */}
              {/* <div className="details_col-con">
                <div className="days_box">
                  <h3><p>Day<span>1</span></p>Day 1 – Personal Consultation</h3>
                  <div className="daytext">
                     <p><b>Personality and Style Blueprint:</b> A complete understanding of your strengths, preferences, and natural style is mapped for you.</p>
                     <p><b>Confidence and Mindset Alignment:</b> Your self-beliefs and mindset blocks are analyzed and strengthened for unstoppable confidence.</p>
                     <p><b>Signature Presence Defined:</b> How you carry yourself, speak, and show up is refined to create maximum impact.</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>2</span></p>Day 2 – Guided Shopping Experience</h3>
                  <div className="daytext">
                     <p><b>Tailored Wardrobe Selection:</b> Outfits perfectly suited to your body, lifestyle, and personality are handpicked with expert guidance.</p>
                     <p><b>Accessories and Styling Perfected:</b> Shoes, bags, jewelry, and essentials are curated to elevate every look effortlessly.</p>
                     <p><b>Ready-to-Wear Daily Solutions:</b> A complete wardrobe is created so dressing stylishly and confidently becomes effortless.</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>3</span></p>Day 3 – Grooming & Confidence Mastery</h3>
                  <div className="daytext">
                     <p><b>Polished Makeup and Skincare Routine:</b> Your personal daily glam and skincare is designed and demonstrated for flawless execution.</p>
                     <p><b>Body Language and Presence Coaching:</b> Posture, gestures, walk, and eye contact are perfected so you radiate confidence naturally.</p>
                     <p><b>Impactful Communication Skills:</b> Speak, interact, and leave an impression effortlessly with coaching applied directly to you.</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>4</span></p>Day 4 – Wardrobe Building and Styling</h3>
                  <div className="daytext">
                     <p><b>Signature Wardrobe Completion:</b> A fully functional wardrobe reflecting your personality and lifestyle is finalized for daily use.</p>
                     <p><b>Essential Pieces Strategized:</b> Shoes, lingerie, accessories, and staples are organized and styled for every occasion.</p>
                     <p><b>Effortless Polished Look:</b> Every outfit is styled and ready to wear so you look confident every day.</p>
                  </div>
                </div>
              </div> */}
          </div>
        </div>
      </div>
    </section>

    <section className="whycho one_whycho event_whychoo">
      <div className="onembr_row">
        <div className="imageoner">
          <img className="imageonerr1" src={imgch} ></img>
           <img className="imageonerr2" src={imgch2} ></img>

        </div>
        <div className="contentoner contentonerr">
          <h2>Why<br></br>Choose This Course</h2>
          <ul>
            <li><img className="num" src={Icon5} ></img><span>Complete Look Curation: Outfit, hair, makeup & accessories—all covered</span></li>
            <li><img className="num" src={Icon6} ></img><span>1:1 Personal Styling: Tailored guidance based on your body type,<br></br> event & vibe</span></li>
            <li><img className="num" src={Icon7} ></img><span>Expert Coordination: Ensures you stand out without overdoing it</span></li>
            <li><img className="num" src={Icon11} ></img><span>End-to-End Experience: From planning to execution, everything<br></br> handled seamlessly</span></li>
            <li><img className="num" src={Iconss11} ></img><span>On-Day Support: Final styling supervision before your big moment</span></li>
          </ul>
          <div className="btngroup">
                {/* <a
                  href="/two-week-transformation"
                  className="terrs_btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                >
                  <img src={iconstrt} alt="" />
                  Get In Touch
                </a> */}
                {/* <a
                  href="#"
                  data-bs-toggle="modal"
                  className="terrs_btn"
                  data-bs-target="#offlineCourseModal"
                >
                  <img src={iconstrt} alt="" />
                  ENROLL NOW
                </a> */}
              </div>
               <div className="skillbox1">
                <img src={Icon411}></img>
                <div className="skillbox1_content">
                  <h2>A private, personalised<br></br> journey designed only for you.</h2>
                  <p>This is Bhavna Singh’s most exclusive<br></br> offering, created for individuals who want <br></br>focused attention, deep inner–outer work,<br></br> and complete confidentiality.</p>
                </div>
            </div>
        </div>
      </div>
    </section>

    <section className="journey">
             <div className="skillbox">
              <h5>Events She Styles</h5>
            <h6>For Every<span className="Occasion"> Occasion</span></h6>
            <ul>
            <li><img className="num" src={dott} ></img> Wedding Functions</li>
            <li><img className="num" src={dott} ></img> Engagements</li>
            <li><img className="num" src={dott} ></img> Cocktail / Sangeet / Reception</li>
            <li><img className="num" src={dott} ></img> Birthdays & Private Celebrations</li>
            <li><img className="num" src={dott} ></img> Brand Events / Red Carpet / Special Occasions</li>
            </ul>
             {/* <div className="animeslide-desc">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><img className='contact_icon' src={staricon} ></img><img className='contact_icon1' src={staricon1} ></img>CONNECT WITH US</a>
                  
                </div> */}
          </div>

    </section>

     <section className="whycho whycho_section2 event_whycho">
      <div className="onembr_row">
         <div className="contentoner">
            <h4>Investment</h4>
          <h2>Details:</h2>
          {/* <ul>
            <li><img className="num" src={Icon311} ></img>
            <div>
               <span className="bold_text">One-on-One Guidance</span><br></br>
               <span className="light_text">100% One-on-One & Confidential</span>
            </div>
           </li>
            <li><img className="num" src={Icon32} ></img><div>
               <span className="bold_text">Real-Time Personality Shift</span><br></br><span className="light_text">Time-Bound & Focused (Not open-ended coaching)</span>
            </div></li>
            <li><img className="num" src={Icon33} ></img><div>
               <span className="bold_text">Practical, Hands-On Learning</span><br></br><span className="light_text">Deep Self-Grooming & Inner Alignment</span>
            </div></li>
            <li><img className="num" src={Icon34} ></img><div>
               <span className="bold_text">Custom Transformation Plan</span><br></br><span className="light_text">Learn what works best for your personality</span>
            </div></li>
             <li className="destop_num_list"><img className="num" src={Icon35} ></img>
             <div>
               <span className="bold_text">Flexible Mode</span><br></br><span className="light_text">Online:<br></br>
Attend from anywhere</span>
            </div>
            <img className="line" src={Iconline} ></img>
            <div>
               <span className="light_text">Offline:</span><br></br><span className="light_text">At Transform with Bhavna Academy, Delhi<br></br>
(Choice entirely yours)</span>
            </div>
            </li>
            <li className="mobile_num_list"> <div><img className="num" src={Icon35} ></img> </div>
            <div>
               <span className="bold_text">Flexible Mode</span><br></br><span className="light_text">Online: Attend from anywhere Offline: At Transform with Bhavna Academy, Delhi (Choice entirely yours)</span>
               </div>
            </li>
          </ul> */}
          <div className="detailss">
          <div className="detail_section">
            <h3>₹50,000 — Per Look Styling</h3>
            <p>Online consultation or in-person at Bhavana Singh Academy</p>
          </div>
           <div className="detail_section">
            <h3>₹1,00,000 — Styling On Event Day</h3>
            <p>Includes personal styling, complete look finalisation & on-ground presence</p>
          </div>
           <div className="btngroup">
                 {/* <a
                  href="#"
                  className="terrs_btn" data-bs-target="#staticBackdrop">
                  <img  src={iconstrt} alt="" />
                 ENROLL NOW
                </a>   */}
                 <a
                href="#"
                data-bs-toggle="modal"
                className="terrs_btn"
                data-bs-target="#staticBackdrop"
              ><img src={iconstrt} alt="" />
                ENROLL NOW
              </a>
          </div>
         </div>
        </div>
        
        <div className="imageoner details_img">
          <img className="imageonerr1" src={imgchh} ></img>
           <img className="imageonerr2" src={imgch1} ></img>

        </div>
  
      </div>

    </section>
    {/* <section className="details_section ">
       <div className="onedetails">
       
               <div className="details_col">
                 <img className="happensss" src={iconprogram} alt="" />
                  <h2>Details:</h2>
                   <ul>
                      <li className="line1"><h4>Duration</h4><spna>1 Month</spna></li>
                      <li className="line2"><h4>Sessions</h4><spna>4 professional Sessions</spna> 
                          <div className="detail_list"> •2 Hours Each<br></br>
                             • Online or Offline (Client’s choice)</div> 
                            </li>
                      <li className="line3"><h4>Support</h4><spna>WhatsApp Support</spna>
                       <div className="detail_list detail_list1">
                             <div>•1 Month of Dedicated <br></br>WhatsApp Support</div>
                            <div>• Styling, grooming,<br></br>confidence, communication,<br></br> anytime you feel stuck</div> </div>
                      </li>
                    </ul>
              </div> 
              <div className="will_work workkkk">
          <h4>What you will work on</h4>
           <img className="happenline" src={iconwill} alt="" />
          <span>
          ✔ Confidence & self-image<br></br>
          ✔ Communication & presence<br></br>
          ✔ Grooming & styling clarity<br></br>
          ✔ Body language & posture<br></br>
          ✔ Social & professional behaviour<br></br>
          ✔ First impressions<br></br>
          ✔ Mindset & self-belief<br></br>
          ✔ Identity refinement
          </span>
            <img className="will_img" src={iconwork} alt="" />
        </div>
             <div className="details_conntent">
                  <div className="details_conntent1">
                    <h4>fees</h4><span>₹3,00,000/- (Inclusive of GST)</span>
                        <h5>Includes:</h5>
                         <ul>
                             • All one-on-one sessions<br></br>
                             • One month WhatsApp support<br></br>
                             • Personalised transformation journey <br></br>
                             • Complete privacy and exclusivity
                        </ul>
                     
                  </div>
                  <div className="details_conntent1">
                    <h4>Important</h4><span>Terms & Conditions</span>
                         <p>
                            The program fee is non-refundable.
                            In case you wish to change the session dates, you may book another available slot.
                            The paid amount will not be refunded or adjusted. All sessions must be completed within the agreed one-month duration.
                         </p>
                    
                  </div>
             </div>
              
               
                
          </div>
    </section>
   <section className="program_section ">
        <div className="happens">
          <h4>What happens after the program</h4>
           <img className="happenline" src={iconline} alt="" />
          <span>⭐ You feel more confident and self-aware<br></br>
                ⭐ You know how to present yourself effortlessly<br></br>
                ⭐ You speak with clarity and assurance<br></br>
                ⭐ No templates.<br></br>
                ⭐ No generic modules – Only what you need.<br></br>
                ⭐ You dress with intention and confidence<br></br>
                ⭐ You stop second-guessing yourself<br></br>
                ⭐ You carry a calm, powerful presence<br></br>
                ⭐ You don’t just improve —<br></br>
                ⭐ You evolve.
          </span>
          <div className="btngroup">
                 <a
                  href="/two-week-transformation"
                  className="terrs_btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                  <img  src={iconstrt} alt="" />
                 ENROL
                </a>  
          </div>
        <img className="happen" src={iconprogram} alt="" />
        </div>
        <div className="will_work">
          <h4>What you will work on</h4>
           <img className="happenline" src={iconwill} alt="" />
          <span>
          ✔ Confidence & self-image<br></br>
          ✔ Communication & presence<br></br>
          ✔ Grooming & styling clarity<br></br>
          ✔ Body language & posture<br></br>
          ✔ Social & professional behaviour<br></br>
          ✔ First impressions<br></br>
          ✔ Mindset & self-belief<br></br>
          ✔ Identity refinement
          </span>
            <img className="will_img" src={iconwork} alt="" />
        </div>
   </section> */}



    {/* <section class="courses_details">
        <div class="container">
            <div class="row">
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                        <h3>Be the Best Version Of</h3>
                        <h2>yourself!</h2>
                        <p>These tailor-made sessions focus on every aspect of your personal style and confidence, from your wardrobe and grooming to your body language and communication skills. With Bhavana’s expert guidance, you’ll embark on a journey to discover your most confident and polished self. Bhavana helps you become the best version of yourself, transforming you from ordinary to extraordinary. Eventually, you’ll have the confidence to own any room you walk into.</p>
                        <h4>What’s Included in Your Transformation Journey?</h4>
                        <div class="listcontent">
                            <div class="accordion" id="accordionExample">
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                 Day 1: Personalized Consultation
                                </h4>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <ul>
                                    <li>In-depth consultation to understand your lifestyle, goals, and unique needs.</li>
                                    <li>Identification of problem areas and areas for improvement.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingTwo" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                 
                                Day 2: Guided Shopping
                                  
                                </h4>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                 
                                  <ul>
                                    <li>Exclusive shopping session for makeup, skincare, and accessories.</li>
                                    <li>Recommendations tailored to your style, preferences, and personality.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingThree" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                 
                                Day 3: Skincare, Makeup & Confidence Training
                                  
                                </h4>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                 
                                  <ul>
                                    
                                    <li>Hands-on practice with skincare routines and makeup techniques.</li>
                                    <li>Mastering body language and posture for a confident presence.</li>
                                  </ul>
                                  
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingfor" data-bs-toggle="collapse" data-bs-target="#collapsefor" aria-expanded="false" aria-controls="collapsefor">
                                 
                                Day 4: Wardrobe Building
                                  
                                </h4>
                                <div id="collapsefor" class="accordion-collapse collapse" aria-labelledby="headingfor" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  
                                  <ul>
                                    <li>Guided shopping for outfits, lingerie, boots, sunglasses, and more.</li>
                                    <li>Personalized styling advice to align with your body type and personality.</li>
                                  </ul>
                                  
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="courses_image">
                        <img src={Couimg} alt="" width="100%"/>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section class="courses_details onepagecontent">
        <div class="container">
            <div class="row">
            <div class="col-md-6">
                    <div class="courses_image imgcoud">
                        <img src={Couimgg} alt="" width="100%" />
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                      
                        <h4>What You Will Gain</h4>
                        <p>These tailor-made sessions focus on every aspect of your personal style and confidence, from your wardrobe and grooming to your body language and communication skills. With Bhavana’s expert guidance, you’ll embark on a journey to discover your most confident and polished self. Bhavana helps you become the best version of yourself, transforming you from ordinary to extraordinary. Eventually, you’ll have the confidence to own any room you walk into.</p>
                      
                        <ul className="secmbr">
                            <li><b>Enhanced Confidence:</b> Learn how to carry yourself with poise and assurance.</li>
                            <li><b>Refined Style:</b> Discover what works best for your hair, skin, body type,   and wardrobe.</li>
                            <li><b>Communication Skills:</b> Improve your speaking and interpersonal skills.</li>
                            <li><b>Polished Presence:</b> Build a lasting impression through your overall appearance and demeanour.</li>
                            <li><b>Extraordinary Transformation:</b> Transition from ordinary to extraordinary and gain the confidence to own every room you walk into.</li>
                        </ul>

                        <div class="courses_contentt">
                            <h4>The Unique Approach</h4>
                            <p>With years of experience transforming personalities and empowering individuals, Bhavana Singh’s practical, hands-on approach ensures you get the most out of every session. She combines her expertise in fashion, grooming, and personal development to create a transformation plan tailored just for you.</p>
                        </div>
                    </div>
                   
                </div>
                
            </div>
        </div>
      </section>
      <section class="courses_sli">
        <div class="container">
            <div class="courses-slide">
                <div class="slide_head">
                    <h3>TRANSFORMATION IN FOCUS </h3>
                    <h2>Sneak Peek and Success Stories</h2>
                    <p>Get a firsthand look at the journey with real moments captured from our live sessions. Watch as confidence builds, style transforms, and true presence unfolds. These reels offer a glimpse into the powerful impact of our program in action.</p>
                </div>
            </div>
            <div class="swiper coursesslide">
            <div class="swiper-wrapper">
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image1}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image2}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image3}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image4}/><img className='playbtnv' src={Playbtn}></img></a></div>
                   
                </div>
            </div>
            <div class="courses_btn">
                <a href="#" data-bs-toggle="modal" data-bs-target="#onlineCourseModal">Enrol Now</a>
                <a >Download Brochure</a>
            </div>
        </div>
      </section> */}

    <div className="modal fade" id="offlineCourseModal" tabIndex="-1" aria-labelledby="offlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Offline Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("offline")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="modal fade" id="onlineCourseModal" tabIndex="-1" aria-labelledby="onlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Online Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("online")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">Bhavana Singh</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default EventStyling;
